/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2019-02-25 17:57:25
 * @LastAuthor: @yangwenshan
 * @lastTime: 2022-01-07 16:26:55
 */
import { UserLayout, RouteView, PageView } from '@/components/Layouts'
import BasicLayout from '@/components/Layouts/BasicLayout.vue'  //此组件暂时只能通过这样引入，不能同上组件引入，否则单元测试报错，原因未知

export const asyncRouterMap = [

  {
    path: '/',
    component: BasicLayout,
    meta: { title: '首页' },
    // invisible: true,
    name: 'index',
    redirect: '/dashboard/workplace',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        redirect: '/dashboard/workplace',
        component: RouteView,
        meta: { title: '仪表盘', icon: 'dashboard' },
        children: [
          {
            path: '/dashboard/workplace',
            name: 'Workplace',
            component: () => import(/* webpackChunkName: "workplace" */'@/views/dashboard/Workplace'),
            meta: { title: '工作台', keepAlive: true }
          }
        ]
      },
      {
        path: '/list',
        component: RouteView,
        name: 'List',
        meta: { title: '名单管理', keepAlive: true, icon: 'team', permission: ['customer_menu'] },
        children: [
          {
            path: '/call-list',
            name: 'CallList',
            component: () => import(/* webpackChunkName: "call-list" */'@/views/list/call-list'),
            meta: { title: '客户名单库', keepAlive: true, permission: ['customer_menu'] }
          },
          {
            path: '/call-list/detail',
            name: 'CallListDetail',
            component: () => import(/* webpackChunkName: "call-list-detail" */'@/views/list/call-list/detail'),
            meta: { title: '客户名单-详情', keepAlive: true },
            // invisible: true,
            hidden: true,
          },
        ]
      },
      {
        path: '/order',
        component: RouteView,
        name: 'Order',
        meta: { title: '订单管理', keepAlive: true, icon: 'schedule', permission: ['order_menu'] },
        children: [
          {
            path: '/order-bill',
            name: 'OrderBill',
            component: () => import(/* webpackChunkName: "order-bill" */'@/views/order/order-bill'),
            meta: { title: '订单', keepAlive: true, permission: ['order_menu'] }
          },
          {
            path: '/correct-order',
            name: 'CorrectOrder',
            component: () => import(/* webpackChunkName: "correct-order" */'@/views/order/correct-order'),
            meta: { title: '批改记录单', keepAlive: true }
          },
        ]
      },
      {
        path: '/compensation',
        component: RouteView,
        name: 'Compensation',
        meta: { title: '理赔管理', keepAlive: true, icon: 'car' },
        children: [
          {
            path: '/report-order',
            name: 'ReportOrder',
            component: () => import(/* webpackChunkName: "report-order" */'@/views/compensation/report-order'),
            meta: { title: '报案单', keepAlive: true }
          },
          {
            path: '/damages-order',
            name: 'DamagesOrder',
            component: () => import(/* webpackChunkName: "damages-order" */'@/views/compensation/damages-order'),
            meta: { title: '定损单', keepAlive: true }
          },
        ]
      },
      {
        path: '/settings',
        component: RouteView,
        name: 'Settings',
        meta: { title: '设置', icon: 'setting', permission: ['setting_menu'] },
        children: [
          {
            path: '/settings/role',
            name: 'Role',
            component: () => import(/* webpackChunkName: "role-setting" */'@/views/settings/role'),
            meta: { title: '角色管理', keepAlive: true }
          },
          {
            path: '/settings/organization',
            name: 'Organization',
            component: () => import(/* webpackChunkName: "organization-setting" */'@/views/settings/organization'),
            meta: { title: '组织机构管理', keepAlive: true }
          },
        ]
      },
      {
        path: '/account',
        component: PageView,
        name: 'Account',
        meta: { title: '个人页', icon: 'user', keepAlive: true },
        children: [
          {
            path: '/account/settings',
            name: 'AccountSettings',
            component: () => import(/* webpackChunkName: "account" */'@/views/account/settings/Index.vue'),
            meta: { title: '个人设置', keepAlive: true },
            redirect: '/account/settings/base',
            alwaysShow: true,
            children: [
              {
                path: '/account/settings/base',
                name: 'BaseSettings',
                component: () => import(/* webpackChunkName: "base-setting" */'@/views/account/settings/BaseSetting'),
                meta: { title: '基本设置', hidden: true, keepAlive: true }
              },
              {
                path: '/account/settings/my-orgs',
                name: 'MyOrgs',
                component: () => import(/* webpackChunkName: "my-orgs-setting" */'@/views/account/settings/my-orgs'),
                meta: { title: '企业/组织/团队', keepAlive: true }
              },
              {
                path: '/account/settings/security',
                name: 'SecuritySettings',
                component: () => import(/* webpackChunkName: "security-setting" */'@/views/account/settings/Security'),
                meta: { title: '安全设置', hidden: true, keepAlive: true }
              },
            ]
          },
        ]
      },
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [

  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user-login" */'@/views/user/Login'),
        meta: { title: '登录' }
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user-register" */ '@/views/user/Register'),
        meta: { title: '注册' }
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user-register-result" */ '@/views/user/RegisterResult'),
        meta: { title: '注册结果' }
      },
      {
        path: 'forgot-password',
        name: 'forgotPassword',
        component: () => import(/* webpackChunkName: "user-forgot-password" */ '@/views/user/ForgotPassword'),
        meta: { title: '找回密码' }
      },
      {
        path: 'recover',
        name: 'recover',
        component: undefined
      },
    ]
  },
  {
    path: '/print-preview',
    name: 'PrintPreview',
    component: () => import(/* webpackChunkName: "order-bill" */'@/views/order/insurance-policy'),
    meta: { title: '单证查验', keepAlive: true, },
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/components/Exception/404')
  },

]



// WEBPACK FOOTER //
// ./src/config/router.config.js